// ligfrontend/src/components/Lig/LigReviewComponent.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { yearsAPI } from "../../services/api";
import LoadingSpinner from "../common/LoadingSpinner";
import "./LigReviewComponent.css";

const LigReviewComponent = () => {
  const navigate = useNavigate();
  const [years, setYears] = useState([]);
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadYears();
  }, []);

  useEffect(() => {
    updateGroups();
  }, [years]);

  const loadYears = async () => {
    try {
      setLoading(true);
      const yearsData = await yearsAPI.getYears(true);
      setYears(yearsData);
    } catch (error) {
      console.error("Error loading years:", error);
    } finally {
      setLoading(false);
    }
  };

  const updateGroups = () => {
    const newGroups = [];
    let temp = [];

    for (let i = 0; i < years.length; i++) {
      temp.push(years[i]);
      if (temp.length > 2) {
        newGroups.push([...temp]);
        temp = [];
      }
    }

    if (temp.length > 0) {
      newGroups.push(temp);
    }

    setGroups(newGroups);
  };

  const handleYearClick = (year) => {
    navigate(`/feed/${year}`);
  };

  if (loading) {
    return <LoadingSpinner message="Loading years..." />;
  }

  return (
    <div className="ligreview-container">
      <div className="ligreview-header">
        <h1 className="ligreview-title">Life is Good Years</h1>
        <p className="ligreview-subtitle">Relive the memories from each year</p>
      </div>

      <div className="years-grid">
        {groups.map((group, groupIndex) => (
          <div key={groupIndex} className="year-row">
            {group.map((year) => (
              <YearCard
                key={year}
                year={year}
                onClick={() => handleYearClick(year)}
              />
            ))}
          </div>
        ))}
      </div>

      {years.length === 0 && (
        <div className="empty-years">
          <div className="empty-years-icon">📅</div>
          <h3>No Years Yet</h3>
          <p>Start documenting your journey to see years appear here!</p>
        </div>
      )}
    </div>
  );
};

const YearCard = ({ year, onClick }) => {
  return (
    <div className="year-card" onClick={onClick}>
      <div className="year-card-inner">
        <div className="year-number">{year}</div>
        <div className="year-decoration">
          <span className="sparkle">✨</span>
        </div>
      </div>
    </div>
  );
};

export default LigReviewComponent;
